import { Text, View } from 'react-native'
import type { ImageSourcePropType } from 'react-native'
import { Avatar } from './Avatar'

interface AvatarInfoProps {
  name?: string
  email?: string
  subtitle?: string
  size?: number
  source?: ImageSourcePropType
  variant?: 'light' | 'dark'
}

export function AvatarInfo({
  name,
  email,
  subtitle,
  size = 44,
  source,
  variant = 'light',
}: AvatarInfoProps) {
  const isDark = variant === 'dark'

  return (
    <View className="flex-row items-center gap-3">
      <Avatar name={name} email={email} size={size} source={source} />
      <View className="min-w-0 flex-1">
        {name ? (
          <Text
            className={`font-semibold ${isDark ? 'text-sm text-inverse' : 'text-base text-primary'}`}
            numberOfLines={1}
          >
            {name}
          </Text>
        ) : null}
        {email ? (
          <Text
            className={`font-normal ${isDark ? 'mt-1 text-xs text-inverse/60' : 'mt-0.5 text-sm text-secondary'}`}
            numberOfLines={1}
          >
            {email}
          </Text>
        ) : null}
        {subtitle ? (
          <Text
            className={`font-normal ${isDark ? 'mt-0.5 text-xs text-inverse/40' : 'mt-1 text-sm text-muted'}`}
            numberOfLines={1}
          >
            {subtitle}
          </Text>
        ) : null}
      </View>
    </View>
  )
}